// removed by extract-text-webpack-plugin
module.exports = {"actions":"edit-columns-modal__actions___3pgK8"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/edit-columns-modal.scss
// module id = 509
// module chunks = 0